module.exports = __webpack_public_path__ + "img/通信储能.b91b6515.png";